import React from 'react';
import { useIdioma } from '../../../i18n/idioma';
import { ChevronRight, Layers } from 'lucide-react';
import { CategoryDef } from '../../../data/categories/registry';
import { EmptyState } from '../../ui/EmptyState';

interface CategoryGridProps {
  categories: CategoryDef[];
  onSelect: (categoryId: string) => void;
  /** Visual hint about which mode this navigator is for. Only affects accent color. */
  mode: 'calculator' | 'templates';
}

const CategoryGrid: React.FC<CategoryGridProps> = ({ categories, onSelect }) => {
    const { t } = useIdioma();
  if (categories.length === 0) {
    return (
      <EmptyState
        icon={<Layers size={18} />}
        title={t('estimado.categorias.vacio_titulo')}
        description={t('estimado.categorias.vacio_descripcion')}
        variant="filtro"
      />
    );
  }

  return (
    <div className="grid grid-cols-2 gap-3 px-1">
      {categories.map(cat => {
        const Icon = cat.icon;
        return (
          <button
            key={cat.id}
            onClick={() => onSelect(cat.id)}
            className="group flex items-start gap-3 p-3 bg-white border border-acero-200 rounded-2xl text-left transition-[border-color] duration-150 hover:border-acero-300 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
          >
            <div className="shrink-0 w-9 h-9 rounded-lg grid place-items-center bg-acero-100 text-acero-600 transition-colors duration-150 group-hover:text-navy-950">
              <Icon size={18} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <span className="font-medium text-navy-950 text-sm leading-tight">{cat.label}</span>
                <ChevronRight size={14} className="text-acero-500 mt-0.5 shrink-0 transition-colors duration-150 group-hover:text-navy-700" />
              </div>
              {cat.note && (
                <p className="text-[11px] text-acero-500 mt-1 leading-snug">{cat.note}</p>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryGrid;
